export const UPDATE_STATUS_FILTER = 'orders/UPDATE_STATUS_FILTER'
export const UPDATE_DATE_FILTER = 'orders/UPDATE_DATE_FILTER'
export const UPDATE_SEARCH_TEXT = 'orders/UPDATE_SEARCH_TEXT'
export const UPDATE_ORDER_LIST = 'orders/UPDATE_ORDER_LIST'


